import { useDispatch, useSelector } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';

import app from './features/app';

const LS_KEY = 'ICHINICHI_STATE';
// Load state from localStorage
const loadState = () => {
    try {
        const serializedState = localStorage.getItem(LS_KEY);
        return serializedState ? JSON.parse(serializedState) : undefined;
    } catch (e) {
        console.warn('Failed to load state from localStorage:', e);
        return undefined;
    }
};

// Save state to localStorage
const saveState = (state: RootState) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem(LS_KEY, serializedState);
    } catch (e) {
        console.warn('Failed to save state to localStorage:', e);
    }
};

export const store = configureStore({
    reducer: {
        // @ts-ignore
        app,
    },
    preloadedState: loadState(),
});

// Subscribe to store changes to save state
store.subscribe(() => {
    saveState(store.getState());
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
